import confetti from 'canvas-confetti';

export const triggerConfetti = (colors = ['#10B981', '#FFD700']) => {
    const duration = 1200;
    const end = Date.now() + duration;

    (function frame() {
        // Confettis venant de la gauche
        confetti({
            particleCount: 3,
            angle: 60,
            spread: 55,
            origin: {x: 0},
            colors: colors
        });

        // Confettis venant de la droite
        confetti({
            particleCount: 3,
            angle: 120,
            spread: 55,
            origin: {x: 1},
            colors: colors
        });

        if (Date.now() < end) {
            requestAnimationFrame(frame);
        }
    }());
};